import * as React from "react";
import { Bar, Line } from "react-chartjs-2";
import { STRATEGY_COLORS, STRATEGY_BACKGROUND_COLORS } from "./colors";
import { Col, Row } from "react-materialize";
import type { StrategyData } from "./sparklingchart";

const windowWidth = () => (typeof window !== "undefined" ? window.innerWidth : 1024);

interface Props {
  allStrategyData: Record<string, StrategyData>;
}

export default class CostChart extends React.Component<Props> {
  render() {
    const data = this.props.allStrategyData;
    const labels = [...Array(Object.keys(data["full_order.greedy"].p_failure_per_day).length).keys()].map(
      (d) => `Day ${d + 1}`,
    );
    return (
      <div>
        <h5>Total Strategy Performance on All Days</h5>
        <p>For each strategy, these are the total costs, failures and runtimes produced for all days in sum.</p>
        <Row>
          <Col l={4} m={12} s={12}>
            <Bar
              data={{
                labels: [""],
                datasets: Object.keys(data).map((strategy) => ({
                  label: strategy,
                  data: [Object.values(data[strategy].total_cost_per_day).reduce((a, b) => a + b, 0)],
                  borderColor: STRATEGY_COLORS[strategy],
                  backgroundColor: STRATEGY_BACKGROUND_COLORS[strategy],
                })),
              }}
              options={{
                scales: {
                  x: { display: true },
                  y: { display: true, title: { display: true, text: "Total Cost / €" } },
                },
                aspectRatio: 1.35,
              }}
            />
          </Col>
          <Col l={4} m={12} s={12}>
            <Bar
              data={{
                labels: [""],
                datasets: Object.keys(data).map((strategy) => ({
                  label: strategy,
                  data: [
                    Object.values(data[strategy].p_failure_per_day).reduce((a, b) => a + b, 0) /
                      Object.values(data[strategy].p_failure_per_day).length,
                  ],
                  borderColor: STRATEGY_COLORS[strategy],
                  backgroundColor: STRATEGY_BACKGROUND_COLORS[strategy],
                })),
              }}
              options={{
                scales: {
                  x: { display: true },
                  y: { display: true, title: { display: true, text: "Failed Orders / %" } },
                },
                aspectRatio: 1.35,
              }}
            />
          </Col>
          <Col l={4} m={12} s={12}>
            <Bar
              data={{
                labels: [""],
                datasets: Object.keys(data).map((strategy) => ({
                  label: strategy,
                  data: [Object.values(data[strategy].calculation_time_per_day).reduce((a, b) => a + b, 0)],
                  borderColor: STRATEGY_COLORS[strategy],
                  backgroundColor: STRATEGY_BACKGROUND_COLORS[strategy],
                })),
              }}
              options={{
                scales: {
                  x: { display: true },
                  y: { display: true, title: { display: true, text: "Runtime / s" }, type: "logarithmic" },
                },
                aspectRatio: 1.35,
              }}
            />
          </Col>
        </Row>
        <h5>Strategy Performance Day-by-day</h5>
        <p>For a more detailed breakdown of each day in the dataset.</p>
        <Line
          data={{
            labels,
            datasets: Object.keys(data).map((strategy) => ({
              label: strategy,
              data: Object.values(data[strategy].total_cost_per_day),
              borderColor: STRATEGY_COLORS[strategy],
              backgroundColor: STRATEGY_BACKGROUND_COLORS[strategy],
            })),
          }}
          options={{
            scales: {
              x: { display: true },
              y: { display: true, title: { display: true, text: "Cost / €" } },
            },
            aspectRatio: windowWidth() > 800 ? 5 : 2.2,
          }}
        />
        <Line
          data={{
            labels,
            datasets: Object.keys(data).map((strategy) => ({
              label: strategy,
              data: Object.values(data[strategy].p_failure_per_day),
              borderColor: STRATEGY_COLORS[strategy],
              backgroundColor: STRATEGY_BACKGROUND_COLORS[strategy],
            })),
          }}
          options={{
            scales: {
              x: { display: true },
              y: { display: true, title: { display: true, text: "Failed Orders / %" } },
            },
            aspectRatio: windowWidth() > 800 ? 5 : 2.2,
          }}
        />
        <Line
          data={{
            labels,
            datasets: Object.keys(data).map((strategy) => ({
              label: strategy,
              data: Object.values(data[strategy].calculation_time_per_day),
              borderColor: STRATEGY_COLORS[strategy],
              backgroundColor: STRATEGY_BACKGROUND_COLORS[strategy],
            })),
          }}
          options={{
            scales: {
              x: { display: true },
              y: { display: true, type: "logarithmic", title: { display: true, text: "Strategy Runtime / s" } },
            },
            aspectRatio: windowWidth() > 800 ? 5 : 2.2,
          }}
        />
      </div>
    );
  }
}
